module.exports = __webpack_public_path__ + "img/examples-ru-2.1ec1e2fb.jpg";